export const CORTEX_ERROR_MESSAGES = {
  NO_ACCOUNT_ID: "Unable to start session. Please sign out and sign back in.",
  GENERIC: "The assistant encountered an error. Please try again.",
};
